const formatNumber = (number) => {
    return number < 10 ? '0' + number : number
}

const parseMoscowTime = (dateString) => {
    const [datePart, timePart] = dateString.split(' ')
    const [year, month, day] = datePart.split('-')
    const [hours, minutes, seconds] = timePart.split(':')

    const moscowDate = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds))

    return new Date(moscowDate.getTime() - 3 * 60 * 60 * 1000)
}

export const initCountdown = (countdown) => {
    const endTime = parseMoscowTime(countdown.dataset.endTime)
    const timeBlocks = countdown.querySelectorAll('.time-block .digits')

    const updateCountdown = () => {
        const now = new Date()
        const localOffset = now.getTimezoneOffset()
        const moscowOffset = -180

        const adjustedNow = new Date(now.getTime() + (localOffset - moscowOffset) * 60 * 1000)
        const timeDiff = endTime - adjustedNow

        if (timeDiff <= 0) {
            clearInterval(timer)
            timeBlocks.forEach((block) => (block.textContent = '00'))

            return
        }

        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
        const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000)

        timeBlocks[0].textContent = formatNumber(days)
        timeBlocks[1].textContent = formatNumber(hours)
        timeBlocks[2].textContent = formatNumber(minutes)
        timeBlocks[3].textContent = formatNumber(seconds)
    }

    updateCountdown()
    const timer = setInterval(updateCountdown, 1000)
}
